$(function(){
  initCollectionList();
});

initCollectionList = () =>{
  $('.initListSlider').slick({
    dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow: $('.standout-collection-slider__controls .prev', this.$container),
    nextArrow: $('.standout-collection-slider__controls .next', this.$container),
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}
